import router from '../router/index'
import dayjs from 'dayjs'
import { week } from '@/constants/general'
import { cookies } from '@/utils/cookies'
import { reqOrderRemind } from '@/api/global'
import { MessageBox } from 'element-ui'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'

// TODO: 拉到vuex
export const behaviorStr = (billInfo, command, contactPhone, serviceList) => {
  let note = ''
  const cars = `${
    billInfo.designationDriver
      ? '指定叫車派遣'
      : '派遣' + billInfo.cars + '輛車'
  }`
  const onLocation = `上車地點:${billInfo.onLocation}`
  const offLocation = `下車地點: ${
    billInfo.offLocation ? billInfo.offLocation : '尚未指定下車地點'
  }`
  const services = `篩選服務:${
    billInfo.serviceList
      ? billInfo.serviceList.split(',').reduce((acc, serviceId, idx) => {
          const serviceName = serviceList.find(
            ({ id }) => id === Number(serviceId),
          ).name
          if (idx === 0) {
            return acc + serviceName
          } else {
            return `${acc}, ${serviceName}`
          }
        }, '')
      : '無選取服務'
  }`
  const passenNum = `乘客人數:${billInfo.passenNum}`
  const passenInline = `進線電話:${billInfo.passengerPhone}`
  const passenPhone = `聯絡電話:${contactPhone}`
  const passenComment = `乘客備註:${command ? command : '無'}`
  const dispatchArea = `派遣區名稱:${
    billInfo.dispatchAreaName ? billInfo.dispatchAreaName : '無'
  }`
  const priorSearcharrivalTime = `預載詢:${
    billInfo.priorSearcharrivalTime ? billInfo.priorSearcharrivalTime : '無'
  }`
  const blackList = `排除呼號：${
    billInfo.blackList
      ? billInfo.blackList.reduce((acc, { callNumber }, idx) => {
          if (idx === 0) {
            return acc + callNumber
          } else {
            return `${acc}, ${callNumber}`
          }
        }, '')
      : '無'
  }`
  const designationDriver = `指定呼號：${
    billInfo.designationDriver
      ? billInfo.designationDriver.reduce((acc, { callNumber }, idx) => {
          if (idx === 0) {
            return acc + callNumber
          } else {
            return `${acc}, ${callNumber}`
          }
        }, '')
      : '無'
  }`
  note = `${cars}, ${onLocation}, ${offLocation}, ${services}, ${passenNum}, ${passenInline}, ${passenPhone}, ${passenComment}, ${dispatchArea}, ${priorSearcharrivalTime}, ${blackList}, ${designationDriver}`
  // console.log(note);
  return note
}

// 瀏覽器說出中文語音訊息，chrome能正常說出訊息，firefox會有奇怪的聲音
export const speakInBrowser = (msg) => {
  const synth = window.speechSynthesis
  const u = new SpeechSynthesisUtterance()
  u.lang = 'zh-TW'
  u.text = msg
  synth.speak(u)
}

// 瀏覽器推送中文提示訊息
export const sendNotify = (msg) => {
  const options = {
    body: msg.body,
    requireInteraction: true,
  }
  const notify = new Notification(msg.title, options)
  notify.onclick = (e) => {
    e.preventDefault()
    setTimeout(notify.close(), 5000)
  }
  notify.onerror = (e) => {
    console.error(e)
  }
}

// 後派單提醒
export const orderRemind = async () => {
  const token = cookies.get('user')
  if (token && !router.currentRoute.query !== 'desktop') {
    try {
      const { success, result } = await reqOrderRemind()
      if (success && result === '提醒') {
        speakInBrowser('目前有後派單需要處理')
        // 區分派車桌面軟體與後台頁面的處理
        // 若是派車桌面軟體則不做後派提示(派車軟體自己做api request)
        // 若是後台頁面則須做後派單的提示
        if (router.currentRoute.query.from !== 'desktop') {
          MessageBox.confirm('目前有後派單需要處理。', '後派單提示訊息', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              BehaviorRecorder.record('點擊', '後派單', '點選後派單提醒 確定')
            })
            .catch(() => {
              BehaviorRecorder.record('點擊', '後派單', '點選後派單提醒 取消')
            })
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
}

/* 取得星期 ex: 星期一、星期二... */
export const getDay = (date) => {
  return week[dayjs(date).format('d')]
}

/* 取得line url */
export const getLineUrl = () => {
  const domainUrl = location.href
  let url = ''
  if (
    domainUrl.includes('daisuki.backstage.gladmobile.com') ||
    domainUrl.includes('backstage.gladmobile.com')
  ) {
    url = 'https://daisuki.line.gladmobile.com'
  } else {
    url = 'https://staging.line.gladmobile.com'
  }
  return url
}

export const formatCarYear = (carYear) => {
  if (carYear === '未填寫' || carYear === null || carYear === undefined)
    return '未填寫'
  if (carYear <= 1) {
    return '<1年'
  } else {
    return `${carYear}年`
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper.js